import SidebarPage from "./SidebarContainer";

export default SidebarPage;
